// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon {
  font-size: 18px;
}

.mat-mdc-icon-button {
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: color ease 0.2s;
}

.mat-mdc-icon-button:hover {
  color: rgb(255, 255, 255);
}

/* TODO(mdc-migration): The following rule targets internal classes of button that may no longer apply for the MDC version.*/
.mat-mdc-icon-button .mat-mdc-button-wrapper > * {
  vertical-align: none !important;
}

mat-form-field.mat-mdc-form-field {
  background-color: rgb(212, 212, 212);
  padding: 10px 10px 0 10px;
}

::ng-deep .mat-mdc-form-field.mat-mdc-focused {
  /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/
}
::ng-deep .mat-mdc-form-field.mat-mdc-focused .mat-mdc-form-field-required-marker {
  color: #000000;
}
::ng-deep .mat-mdc-form-field.mat-mdc-focused .mat-mdc-input-element {
  color: #000000;
}

.icon-confirm {
  font-size: 20px !important;
}

.buttonAffecto ::ng-deep {
  width: auto;
  display: block;
  height: auto;
  line-height: 14px;
}
.buttonAffecto ::ng-deep span {
  display: contents;
}

button > div:hover {
  text-decoration: underline;
}

a:visited {
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

a:active {
  text-decoration: underline;
}

.input-file {
  display: none;
}

.label-file {
  cursor: pointer;
}

::ng-deep .mat-mdc-text-field-wrapper {
  background-color: white !important;
}`, "",{"version":3,"sources":["webpack://./src/app/+home/+kanban/board/board-item/board-item.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,2BAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA,4HAAA;AACA;EACE,+BAAA;AACF;;AAEA;EACE,oCAAA;EACA,yBAAA;AACF;;AAEA;EACE,gIAAA;AACF;AAAE;EACI,cAAA;AAEN;AAAE;EACI,cAAA;AAEN;;AAEA;EACE,0BAAA;AACF;;AAGE;EACE,WAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;AAAJ;AAII;EACE,iBAAA;AAFN;;AAOA;EACE,0BAAA;AAJF;;AAOA;EACE,qBAAA;AAJF;;AAOA;EACE,0BAAA;AAJF;;AAOA;EACE,0BAAA;AAJF;;AAQA;EACE,aAAA;AALF;;AAQA;EACE,eAAA;AALF;;AAOA;EACE,kCAAA;AAJF","sourcesContent":[".icon {\r\n  font-size: 18px;\r\n}\r\n\r\n.mat-mdc-icon-button {\r\n  width: 25px;\r\n  height: 25px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  transition: color ease .2s;\r\n}\r\n\r\n.mat-mdc-icon-button:hover {\r\n  color: rgb(255, 255, 255);\r\n}\r\n\r\n/* TODO(mdc-migration): The following rule targets internal classes of button that may no longer apply for the MDC version.*/\r\n.mat-mdc-icon-button .mat-mdc-button-wrapper>* {\r\n  vertical-align: none !important;\r\n}\r\n\r\nmat-form-field.mat-mdc-form-field {\r\n  background-color: rgb(212, 212, 212);\r\n  padding: 10px 10px 0 10px;\r\n}\r\n\r\n::ng-deep .mat-mdc-form-field.mat-mdc-focused {\r\n  /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/\r\n  .mat-mdc-form-field-required-marker {\r\n      color: #000000;\r\n  }\r\n  .mat-mdc-input-element {\r\n      color: #000000;\r\n  }\r\n}\r\n\r\n.icon-confirm {\r\n  font-size: 20px !important;\r\n}\r\n\r\n.buttonAffecto{\r\n  ::ng-deep {\r\n    width: auto;\r\n    display: block;\r\n    height: auto;\r\n    line-height: 14px;\r\n  }\r\n\r\n  ::ng-deep{\r\n    span{\r\n      display: contents;\r\n    }\r\n  }\r\n\r\n}\r\nbutton > div:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\na:visited {\r\n  text-decoration: none;\r\n}\r\n\r\na:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\na:active {\r\n  text-decoration: underline;\r\n}\r\n\r\n// et on masque le input\r\n.input-file {\r\n  display: none;\r\n}\r\n\r\n.label-file{\r\n  cursor: pointer\r\n}\r\n::ng-deep .mat-mdc-text-field-wrapper {\r\n  background-color: white !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
